(() => {
  'use strict';

  const ROOT = '.affiliates-landing';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealInit(section) {
    const nodes = section.querySelectorAll('[data-aff-reveal]');
    if (!nodes.length) return;

    if (prefersReducedMotion || document.body.classList.contains('animate--none')) {
      nodes.forEach((el) => el.classList.add('is-inview'));
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            obs.unobserve(entry.target);
          }
        });
      },
      { root: null, threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );

    nodes.forEach((el) => obs.observe(el));
  }

  function jumpNavInit(section) {
    const nav = section.querySelector('[data-aff-jump-nav]');
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    const ids = links
      .map((a) => a.getAttribute('href').slice(1))
      .filter(Boolean);
    const sections = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!sections.length) return;

    const setActive = (id) => {
      links.forEach((a) => {
        const on = a.getAttribute('href') === `#${id}`;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
    };

    if (prefersReducedMotion || document.body.classList.contains('animate--none')) {
      setActive(ids[0]);
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { root: null, threshold: 0.25, rootMargin: '-20% 0px -55% 0px' }
    );

    sections.forEach((el) => obs.observe(el));
  }

  function smoothScrollInit(section) {
    section.addEventListener('click', (e) => {
      const t = e.target.closest('[data-aff-smooth]');
      if (!t || !section.contains(t)) return;
      const href = t.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', href);
    });
  }

  function pillarTiltInit(section) {
    if (prefersReducedMotion || window.matchMedia('(max-width: 989px)').matches) return;

    section.querySelectorAll('[data-aff-tilt]').forEach((card) => {
      const inner = card.querySelector('[data-aff-tilt-inner]');
      if (!inner) return;

      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateZ(0)`;
      });

      card.addEventListener('mouseleave', () => {
        inner.style.transform = '';
      });
    });
  }

  function stepCardsInit(section) {
    const wrap = section.querySelector('[data-aff-steps]');
    if (!wrap) return;
    const cards = Array.from(wrap.querySelectorAll('[data-aff-step-card]'));
    if (!cards.length) return;

    cards.forEach((card, i) => {
      card.addEventListener('mouseenter', () => {
        cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
      });
    });

    wrap.addEventListener('mouseleave', () => {
      cards.forEach((c) => c.classList.remove('is-active'));
    });

    cards.forEach((card) => {
      card.addEventListener('focus', () => {
        const i = cards.indexOf(card);
        cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
      });
    });
  }

  class AffiliatesLanding {
    constructor(section) {
      this.section = section;
      revealInit(section);
      jumpNavInit(section);
      smoothScrollInit(section);
      pillarTiltInit(section);
      stepCardsInit(section);
    }
  }

  const boot = () => {
    document.querySelectorAll(ROOT).forEach((section) => {
      if (section.__affiliatesLanding) return;
      section.__affiliatesLanding = new AffiliatesLanding(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.matches(ROOT) ? e.target : e.target.querySelector(ROOT);
    if (!root || root.__affiliatesLanding) return;
    root.__affiliatesLanding = new AffiliatesLanding(root);
  });
})();
